import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchMailAccounts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('v1/integration/email/accounts', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchMailAccount(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`v1/integration/email/accounts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createMailAccount(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('v1/integration/email/accounts', payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    syncMailAccount(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`v1/integration/email/accounts/${id}/sync`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteMailAccount(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`v1/integration/email/accounts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // --- Enrollment invites ---
    fetchInvites(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('v1/integration/email/accounts/invites', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createInvite(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post('v1/integration/email/accounts/invites', payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    resendInvite(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`v1/integration/email/accounts/invites/${id}/resend`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    revokeInvite(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`v1/integration/email/accounts/invites/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // --- Public enrollment (no auth required) ---
    fetchPublicInvite(ctx, { token }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`v1/integration/email/enroll/${token}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    startEnrollment(ctx, { token }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`v1/integration/email/enroll/${token}/start`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
